import React, { Component } from "react";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";

class VideoV2 extends Component {
  render() {
    const { whyUs, lang, loading } = this.props.appData;

    // Dil seçimi + fallback
    const t =
      whyUs?.translations?.[lang] ||
      whyUs?.translations?.tr ||
      whyUs?.translations?.en ||
      {};
    const items = Array.isArray(t.list) ? t.list : [];

    return (
      <div className="ltn__about-us-area section-bg-1 bg-image-right-before pt-120 pb-90">
        {!loading && whyUs && (
          <>
            <style>
              {`
                .ltn__about-us-area.bg-image-right-before::before {
                  background-image: url("${fileUrl(API_FILE_URL, whyUs.cover)}");
                }
              `}
            </style>

            <div className="container">
              <div className="row">
                <div className="col-lg-6 align-self-center">
                  <div className="about-us-info-wrap">
                    <div className="section-title-area ltn__section-title-2--- mb-20">
                      <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                        {t.subtitle || ""}
                      </h6>
                      <h1 className="section-title">{t.title || ""}</h1>
                      <p>{t.content || ""}</p>
                    </div>

                    <ul className="ltn__list-item-half ltn__list-item-half-2 list-item-margin clearfix">
                      {items.map((text, i) => (
                        <li key={i}>
                          <i className="icon-done" />
                          {text}
                        </li>
                      ))}
                    </ul>

                    <div className="ltn__animation-pulse2 text-center mt-30">
                      <a
                        className="ltn__video-play-btn bg-white--- ltn__secondary-bg"
                        href={whyUs.videoIframe || "#"}
                        data-rel="lightcase"
                      >
                        <i className="icon-play ltn__secondary-color--- white-color" />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 align-self-center">
                  <div className="about-us-img-wrap about-img-left"></div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default withAppData(VideoV2);
